import {createSlice,PayloadAction} from '@reduxjs/toolkit';
import {User} from '../types';

interface AuthState { user: User|null; token: string|null; isAuthenticated: boolean; loading: boolean; locationId: string|null; locationName: string|null; stationId: string|null; stationName: string|null; }

const initialState: AuthState = {
  user: null,
  token: localStorage.getItem('accessToken'),
  isAuthenticated: !!localStorage.getItem('accessToken'),
  loading: false,
  locationId: localStorage.getItem('locationId'),
  locationName: localStorage.getItem('locationName'),
  stationId: localStorage.getItem('stationId'),
  stationName: localStorage.getItem('stationName'),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action: PayloadAction<{user:User;token:string}>) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      localStorage.setItem('accessToken', action.payload.token);
    },
    setLocationStation(state, action: PayloadAction<{locationId:string;locationName:string;stationId:string;stationName:string}>) {
      state.locationId = action.payload.locationId;
      state.locationName = action.payload.locationName;
      state.stationId = action.payload.stationId;
      state.stationName = action.payload.stationName;
      localStorage.setItem('locationId', action.payload.locationId);
      localStorage.setItem('locationName', action.payload.locationName);
      localStorage.setItem('stationId', action.payload.stationId);
      localStorage.setItem('stationName', action.payload.stationName);
      // Also set as active branch for all API calls
      localStorage.setItem('activeBranchId', action.payload.locationId);
    },
    setUser(state, action: PayloadAction<User>) { state.user = action.payload; },
    logout(state) {
      state.user = null; state.token = null; state.isAuthenticated = false;
      state.locationId = null; state.locationName = null; state.stationId = null; state.stationName = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('locationId'); localStorage.removeItem('locationName');
      localStorage.removeItem('stationId'); localStorage.removeItem('stationName');
      localStorage.removeItem('activeBranchId');
      localStorage.removeItem('accessibleModules');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userName');
      localStorage.removeItem('userId');
    },
    setLoading(state, action: PayloadAction<boolean>) { state.loading = action.payload; },
  },
});

export const {setCredentials,setUser,logout,setLoading,setLocationStation} = authSlice.actions;
export default authSlice.reducer;
